//https://github.com/gaearon/redux-devtools/blob/master/docs/Walkthrough.md
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'testing') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}
